import { Zap } from "lucide-react";
import { STORM_LEVELS, STORM_THRESHOLDS } from "./StormLayer";

const COLORS = ["#71717a", "#5497D5", "#9945FF", "#00FFD1"];

const fmtVol = (v) => {
  if (v == null) return "—";
  if (v >= 1000000) return `$${(v / 1000000).toFixed(2)}M`;
  return `$${Math.round(v).toLocaleString("en-US")}`;
};

const gaugeFill = (v) => {
  if (v == null) return 0;
  const [t0, t1, t2] = STORM_THRESHOLDS;
  if (v >= t2) return 100;
  if (v >= t1) return 66.6 + ((v - t1) / (t2 - t1)) * 33.4;
  if (v >= t0) return 33.3 + ((v - t0) / (t1 - t0)) * 33.3;
  return (v / t0) * 33.3;
};

export const StormMeter = ({ volume, level }) => (
  <div
    data-testid="storm-meter"
    className="neon-card mt-6 px-5 py-4 sm:px-7 flex flex-wrap items-center gap-x-8 gap-y-3"
  >
    <div className="flex items-center gap-3">
      <Zap size={20} style={{ color: COLORS[level] }} className={level >= 2 ? "flicker" : ""} />
      <div>
        <p className="font-bebas tracking-[0.3em] text-zinc-500 text-xs">STORM METER</p>
        <p
          data-testid="storm-level"
          className={`font-bebas text-2xl tracking-widest leading-none mt-0.5 ${level === 3 ? "storm-raging-text" : ""}`}
          style={{ color: COLORS[level], transition: "color 1.5s ease" }}
        >
          {STORM_LEVELS[level]}
        </p>
      </div>
    </div>

    <div className="flex-1 min-w-[140px]">
      <div className="storm-gauge h-2.5 rounded-full bg-white/10 overflow-hidden border border-white/10">
        <div
          className="h-full rounded-full"
          data-testid="storm-gauge-fill"
          style={{
            width: `${Math.max(2, gaugeFill(volume))}%`,
            background: "linear-gradient(90deg, #9945FF 0%, #5497D5 50%, #14F195 100%)",
            boxShadow: level >= 2 ? "0 0 14px rgba(20,241,149,0.6)" : "none",
            transition: "width 1.8s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 1.8s ease",
          }}
        />
      </div>
      <div className="flex justify-between mt-1.5">
        {STORM_LEVELS.map((l, i) => (
          <span key={l} className="font-mono text-[9px] tracking-wider" style={{ color: i <= level ? COLORS[level] : "#3f3f46" }}>
            {l}
          </span>
        ))}
      </div>
    </div>

    <div className="text-right">
      <p className="font-bebas tracking-[0.25em] text-zinc-500 text-xs">24H VOLUME</p>
      <p data-testid="storm-volume" className="font-bebas text-2xl text-white leading-none mt-0.5">
        {fmtVol(volume)}
      </p>
    </div>

    {level === 3 && (
      <div
        data-testid="storm-raging-badge"
        className="w-full sm:w-auto font-marker text-sm px-3 py-1.5 rounded-lg -rotate-1 text-[#050409] bg-[#00FFD1] shadow-[0_0_26px_rgba(0,255,209,0.6)]"
      >
        ⚡ THE STORM IS RAGING · {fmtVol(volume)} 24H
      </div>
    )}
  </div>
);
